import { Card, CardContent, Grid2 } from "@mui/material";
import DetalleLiquidacion from "../components/detalleLiquidacion";
import { OrigenDetalleMutuo, StatusCode } from "../../../utils/enums";
import { useDetalleMutuo } from "../../../context/mutuoContext";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumb from "../../../components/ui/materialui/breadcrumb";
import TablaDesarrolloLiquidacion from "../components/tablaDesarrolloLiquidacion";
import CustomAccordion from "../../../components/ui/materialui/customAccordion";
import { IsDesactivado } from "../../detalleMutuo/services/servicesMutuo";

const Liquidacion: React.FC = () => {

    const location = useLocation();
    const { id: idEmergente } = location.state || {}
    const [idMutuo, setIdMutuo] = useState<number>(idEmergente);
    const { id, nombre, filtros, tipoMutuo, idSolicitud, numeroOperacion } = useDetalleMutuo();
    const [isDesactivado, setIsDesactivado] = useState(false);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cartera mutuos', state: filtros, url: '/cartera-mutuos' },
        { label: 'Liquidacion', active: true },
        { label: `${numeroOperacion ?? ''} - ${tipoMutuo ?? ""} - ${nombre ?? ''}`, active: true },
    ]

       const EsDesactivado = async (mutuoId: number) => {
        const resp = await IsDesactivado(mutuoId);
        if (resp.status === StatusCode.Ok) {
            setIsDesactivado(resp.data.valor);
        }
    }

    useEffect(() => {
        EsDesactivado(idMutuo);
    }, [idMutuo])

    return (
        <>
            <Grid2 size={{ xs: 12, lg: 8 }}>
                <Breadcrumb items={breadcrumbItems} />
            </Grid2>
            <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
                <CardContent>
                    <DetalleLiquidacion idMutuo={idMutuo} isDesactivado={isDesactivado}/>
                </CardContent>
            </Card>
        </>       
    )
}   

export default Liquidacion;